import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  isLoading = false;
  isSubmitted = false;
  oddsProvider: string;
  fancyProvider: string;
  isLoadingM = false;
  isSubmittedM = false;
  constructor(private matchService: MatchService) { }

  ngOnInit() {
    this.oddsProvider = 'neeraj';
    this.fancyProvider = 'sky';
    this.matchService.getProviders().subscribe(res => {
      if (res['data'] != null) {
        this.oddsProvider = res['data'].odds;
        this.fancyProvider = res['data'].fancy;
      }
    });
  }

  onProviderChange() {
    let oddsProvider = (<HTMLSelectElement>document.getElementById('oddsProvider')).value;
    let fancyProvider = (<HTMLSelectElement>document.getElementById('fancyProvider')).value;
    this.isLoading = true;
    this.isSubmitted = true;
    this.matchService.setProviders(oddsProvider, fancyProvider).subscribe((response) => {
      this.isSubmitted = false;
      this.isLoading = false;
      this.msgSuccess();
    },
      error => {
        this.isSubmitted = false;
        this.isLoading = false;
        this.msgFailure();
      });
  }

  setMessage() {
    let message = (<HTMLSelectElement>document.getElementById('message')).value;
    this.isLoadingM = true;
    this.isSubmittedM = true;
    this.matchService.setMessage({ message }).subscribe((response) => {
      this.isSubmittedM = false;
      this.isLoadingM = false;
      this.msgSuccess();
    },
      error => {
        this.isSubmittedM = false;
        this.isLoadingM = false;
        this.msgFailure();
      });
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Update!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }
}